/*
 * Per-page affiliate disclosure reveal.
 * Shows the FTC disclosure (rendered hidden by snippets/affiliate-disclosure.liquid)
 * exactly once, only on pages that contain an outbound Audible / Amazon-affiliate
 * link or CTA. Static, non-tracking — outside the cookie-consent path.
 */
(function () {
  if (window.__ncAffiliateDisclosureLoaded) return;
  window.__ncAffiliateDisclosureLoaded = true;

  function reveal() {
    var note = document.querySelector('[data-affiliate-disclosure]');
    if (!note) return;

    // An affiliate link is present if the page has an Audible product CTA,
    // the trial link/card, or any outbound audible.com / tagged Amazon link.
    var hasAffiliateLink = document.querySelector(
      '.button--audible, .audible-trial-link, .audible-trial-card, ' +
      'a[href*="audible.com"], a[href*="tag=ncaudio0c-20"], ' +
      '[onclick*="audible.com"], [onclick*="tag=ncaudio0c-20"]'
    );

    if (hasAffiliateLink) {
      note.hidden = false;
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', reveal);
  } else {
    reveal();
  }
})();
